module.exports = require('./helpers/bundle-url').getBundleURL('2av5d') + "janeckova.cbcb6cdd.jpg";